import { render, staticRenderFns } from "./NewHero.vue?vue&type=template&id=e9cac44c&"
import script from "./NewHero.vue?vue&type=script&lang=js&"
export * from "./NewHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports